// @core/api/endpoints/team/cancel_team_invitation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CancelTeamInvitationRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Cancel team invitation
 * Cancels a pending team invitation before it is accepted or declined. Only team admins can cancel invitations.
 */
export async function CancelTeamInvitation(
  invitation_id: string,
  data: CancelTeamInvitationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/invitations/:invitation_id/cancel`;
  requestPath = requestPath.replace(':invitation_id', encodeURIComponent(invitation_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
